import React from 'react';
import { theme } from 'antd';
import { MinusOutlined } from '@ant-design/icons';

interface SizeIndicatorProps {
  text?: string;
}

export default function SizeIndicator({ text }: SizeIndicatorProps) {
  const { token } = theme.useToken();
  // Algunas pantallas pasan el nombre completo ('Mediano') y otras la inicial ('M').
  const initial = text?.[0]?.toUpperCase();
  // El fallback nunca puede ser colorBgBase: el texto usa ese mismo color y queda invisible.
  let background = token.colorPrimary;
  switch (initial) {
    case 'D':
      background = 'lightgrey';
      break;
    case 'C':
      background = '#74C2E1';
      break;
    case 'M':
      background = '#3F7D60';
      break;
    case 'G':
      background = '#D67CA6';
      break;
    case 'P':
      background = '#0DB8B2';
      break;
    default:
      break;
  }

  if (!initial) return <MinusOutlined />;

  return (
    <span
      style={{
        background,
        padding: 3,
        color: token.colorBgBase,
        borderRadius: '10px',
        fontWeight: 'bold',
      }}
    >
      {initial}
    </span>
  );
}
